export default __webpack_public_path__ + "static/media/PaymentHistory.db34dc68.svg";